/****
 * Custom hook that synchronizes authentication state across
 * multiple browser tabs and windows.
 *
 * Listens for logout events stored in localStorage, clears
 * MSAL and application state, and redirects users to the
 * login screen when a logout occurs in another tab.
 */
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

import { setAccount, setStatus } from "@/store/authSlice";
import { useAppDispatch } from "@/store/hooks";
import { resetRoleState } from "@/store/userSlice";

export const useGlobalAuthSync = () => {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      // LOGOUT SYNC
      if (event.key === "msal-logout") {

        // Clear MSAL
        instance.setActiveAccount(null);

        // Clear Redux / app state
        dispatch(resetRoleState());
        dispatch(setAccount(null));
        dispatch(setStatus("signedOut"));

        // Force redirect to origin
        window.location.href = window.location.origin;
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [instance, dispatch]);
};
